module.exports = __webpack_public_path__ + "1fa1dc8460c1035feb6a74ed0698fff1.jpg";